export default __webpack_public_path__ + "static/media/tooltip.7da3c895.svg";